// extracted by css-extract-rspack-plugin
export default {"scopeSelect":"KVUEksLXbYJrKtLV"};